import ProgressBar from "../kits/progress/ProgressBar";
import { Modal } from "react-bootstrap";
import { useState, useContext } from "react";
import CustomButton from "../kits/button/CustomButton";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import { GridIcon } from "../kits/Icons";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

export default function ProgressModal({ addLeads, leads, campaignId, val }) {
  const [progressShow, setProgressShow] = useState(false);
  const { userInfo } = useContext(AuthenticationContext);

  console.log("Ssssss", val);
  return (
    <div>
      {userInfo.userRoll.includes(24) && (
        <CustomTooltip
          title="شروع ساخت سرنخ ها"
          placement="top"
          color="secondary_custom"
        >
          <div>
            <CustomButton
              className=" shadow-none"
              type="outline"
              onClick={() => {
                addLeads(campaignId);
                if (val?.progressbarShow == true) setProgressShow(true);
                else if (val?.progressbarShow == false) setProgressShow(false);
              }}
            >
              <GridIcon color="white"></GridIcon>
            </CustomButton>
          </div>
        </CustomTooltip>
      )}

      <Modal show={progressShow} centered>
        <Modal.Header> افزودن سرنخ {val.title}</Modal.Header>
        <Modal.Body>
          <div>
            <button onClick={() => setProgressShow(false)}>close</button>
            <ProgressBar
              progressbarShow={true}
              color={"red"}
              width={10}
              total={leads.length}
              done={val.done}
              type="line"
              circleWidth={300}
              circleHeight={50}
              description={val.description}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
